export default __webpack_public_path__ + "9dfe62739fb695b6ad09fe73177a9de8.png";